import React from 'react';
import styled from "styled-components";
import CardImage from "./components/card.image";
import CardInfo from "./components/card.info";
import CardContact, {ContactButton} from "./components/card.contact";
import {isEmpty} from "../../helpers/helpers";

const PropertyCard = ({property, isBadeSaba, mapKey, setContactInfo, selectedFiltersDistrict, selectedCityFilter, handleShowProperty, handleBookmark, bookmarkedProperties, categories, setForceShowNoResult}) => {
    const {media} = property;
    let imgCount = 0, videoCount = 0;

    if (!isEmpty(media) && media.length) {
        for (let item of media) {
            if (item.type === 'video') {
                videoCount += 1;
            } else {
                imgCount += 1;
            }
        }
    }

    const handleShowNoResult = () => {
        setForceShowNoResult(true)
    };

    return (
        <Property key={mapKey} className={"mx-24 mx-md-0 property-container " + (property.archived ? 'is-archived' : '') + (' property-container-' + property.id)}>
            <Figure>
                <CardImage
                    handleShowProperty={handleShowProperty}
                    property={property}
                    setContactInfo={setContactInfo}
                    handleBookmark={handleBookmark}
                    bookmarkedProperties={bookmarkedProperties}
                    categories={categories}
                    handleShowNoResult={handleShowNoResult}
                    selectedCityFilter={selectedCityFilter}
                    imgCount={imgCount}
                    videoCount={videoCount}
                    isBadeSaba={isBadeSaba}
                />

                <CardInfo
                    handleShowProperty={handleShowProperty}
                    property={property}
                    categories={categories}
                    handleShowNoResult={handleShowNoResult}
                    selectedFiltersDistrict={selectedFiltersDistrict}
                    selectedCityFilter={selectedCityFilter}
                    videoCount={videoCount}
                    isBadeSaba={isBadeSaba}
                />

                <CardContact
                    isBadeSaba={isBadeSaba}
                    property={property}
                    categories={categories}
                    setContactInfo={setContactInfo}
                    className="d-none d-lg-flex flex-column"/>
            </Figure>
        </Property>
    );
};

function propsAreEqual(prevProps, nextProps) {
    return (JSON.stringify(prevProps.property) === JSON.stringify(nextProps.property) &&
        (!isEmpty(prevProps.selectedFiltersDistrict) && prevProps.selectedFiltersDistrict.length) &&
        (prevProps.bookmarkedProperties.length === nextProps.bookmarkedProperties.length)
    );
}

export default React.memo(PropertyCard, propsAreEqual);

// *********
// styles
// *********
const Property = styled.div`
    position: relative;
    padding: 24px 0;
    transition: all .2s ease-in-out;
    border-bottom: 1px solid ${props => props.theme.gray200};
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        padding: 24px 0;
    }
    
    @media (min-width: ${props => props.theme.screenSmMax}) {
        &:hover {
            box-shadow: 0 12px 12px -12px rgba(0,0,0,.2), 0 -12px 12px -12px rgba(0,0,0,.2);
            z-index: 1;
            
            &:not(.is-archived) {
                ${ContactButton} {
                    color: ${props => props.theme.white};
                    background-color: ${props => props.theme.secondary};
                    border-color: ${props => props.theme.secondary};
                    
                    .icons {
                        svg {
                          path {
                            stroke: ${props => props.theme.white};
                          }
                        }
                    }
                }
            }
        }
    }
`;

const Figure = styled.figure`
    display: flex;
    @media (max-width: ${props => props.theme.screenXsMax}) {
        display: block;
    }
`;